module.exports = __webpack_public_path__ + "static/media/Motorbike.c468ab42.svg";